import React, { useState, useEffect, useRef } from 'react';
import axios from '../../Axiosinstance';
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faBook,
  faMapMarkerAlt,
  faChartLine,
  faCog,
  faQuestionCircle,
  faFolder,
  faUser,
  faSignOutAlt,faComments, faBuilding,faUserCircle
} from "@fortawesome/free-solid-svg-icons";
import { Badge } from '@mui/material';
import MailIcon from '@mui/icons-material/Mail';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Header.css';
import { Modal, Button } from 'react-bootstrap';
import { logoImage } from '../../common';
import NotificationsIcon from '@mui/icons-material/Notifications';


function App() {
  const [isResourcesOpen, setResourcesOpen] = useState(false);
  const [isHelpOpen, setHelpOpen] = useState(false);
  const [isAccountOpen, setAccountOpen] = useState(false);
  const [isNavOpen, setNavOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [showNotificationsModal, setShowNotificationsModal] = useState(false);

  const [hover, setHover] = useState(false);

  const resourcesRef = useRef(null);
  const helpRef = useRef(null);
  const accountRef = useRef(null);

  const openModal = () => {
    setShowModal(true);
  };


  const openNotificationsModal = () => {
    axios.get('admin-notifications/unseen')
      .then(response => {
        if (response.status === 200) {
          setNotifications(response.data);
          setShowNotificationsModal(true);
        }
      })
      .catch(error => {
        console.error('Error fetching notifications:', error);
      });
  };

  const closeNotificationsModal = () => {
    setShowNotificationsModal(false);
  };

  const toggleResources = (e) => {
    setResourcesOpen(!isResourcesOpen);
    setHelpOpen(false);
    setAccountOpen(false);
  };

  const toggleHelp = () => {
    setHelpOpen(!isHelpOpen);
    setResourcesOpen(false);
    setAccountOpen(false);
  };

  const toggleAccount = () => {
    setAccountOpen(!isAccountOpen);
    setResourcesOpen(false);
    setHelpOpen(false);
  };

  const [isHamburgerActive, setHamburgerActive] = useState(false);
  const [isNavActive, setNavActive] = useState(false);
  const navigate = useNavigate();
  const [studentName, setStudentName] = useState(null);
  const [profileUrl, setProfileUrl] = useState(null);

  const handleLogout = () => {
    localStorage.removeItem("loggedInUserId");
    localStorage.removeItem("usertype");
    localStorage.removeItem("studentteacherid");
    localStorage.removeItem('jwtToken');
    localStorage.removeItem('userId');
    localStorage.removeItem('username');
    document.title = "LMS-impluz";
    openModal();
  };

  useEffect(() => {
    const userId = localStorage.getItem("userId");

    if (userId) {
      axios.get(`home/user/${userId}`)
        .then((response) => {
          if (response.status === 200) {
            const data = response.data;
            localStorage.setItem("studentteacherid", data.sfid);
            document.title = `impluz - ${data.name}`;
            setStudentName(data.name);
            setProfileUrl(data.profile_Url);
          } else {
            throw new Error("Failed to fetch sfid");
          }
        })
        .catch((error) => {
          console.error(error.response);
          if (error == "AxiosError: Network Error")
            handleLogout();
        });
    }
  }, []);

  const toggleHamburger = () => {
    setHamburgerActive((prevState) => !prevState);
    setNavActive((prevState) => !prevState);
  };

  const toggleNav = () => {
    setNavOpen(!isNavOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (resourcesRef.current && !resourcesRef.current.contains(event.target)) {
        setResourcesOpen(false);
      }
      if (helpRef.current && !helpRef.current.contains(event.target)) {
        setHelpOpen(false);
      }
      if (accountRef.current && !accountRef.current.contains(event.target)) {
        setAccountOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Fetch notification count
  useEffect(() => {
    const fetchNotificationCount = () => {
      axios.get('admin-notifications/unseen-count')
        .then(response => {
          if (response.status === 200) {
            setNotificationCount(response.data); // Assuming response.data.count contains the count
          }
        })
        .catch(error => {
          console.error('Error fetching notification count:', error);
        });
    };

    // Fetch notifications every 5 minutes
    fetchNotificationCount();
    const intervalId = setInterval(fetchNotificationCount, 300000); // 300000 ms = 5 minutes

    return () => clearInterval(intervalId); // Cleanup interval on component unmount
  }, []);

  const markNotificationAsSeen = (id) => {
    axios.post(`admin-notifications/${id}/seen`)
      .then(() => {
        // Re-fetch the notifications after marking one as seen
        openNotificationsModal();
        // Optionally, update the notification count
        axios.get('admin-notifications/unseen-count')
          .then(response => {
            if (response.status === 200) {
              setNotificationCount(response.data);
            }
          })
          .catch(error => {
            console.error('Error fetching notification count:', error);
          });
      })
      .catch(error => {
        console.error('Error marking notification as seen:', error);
      });
  };

  const markAllNotificationsAsSeen = () => {
    axios.post('admin-notifications/mark-all-seen')
      .then(() => {
        // Re-fetch the notifications after marking all as seen
        openNotificationsModal();
        // Update the notification count
        axios.get('admin-notifications/unseen-count')
          .then(response => {
            if (response.status === 200) {
              setNotificationCount(response.data);
            }
          })
          .catch(error => {
            console.error('Error fetching notification count:', error);
          });
      })
      .catch(error => {
        console.error('Error marking all notifications as seen:', error);
      });
  };


  const itemStyle = {
    transition: 'background-color 0.3s',
    cursor: 'pointer',
    backgroundColor: hover ? '#f0f0f0' : 'transparent', // Change background color on hover
    color: hover ? '#FFC300' : 'inherit', // Change text/icon color on hover
    borderRadius: hover ? '30%' : '0', // Add border-radius on hover
    padding: '20px', // Optional: to ensure some space around the content
  };

  return (
    <div className={`App ${isNavOpen ? 'opened' : ''}`}>
      <nav>
        <div className="logo">
          <Link to='/wsq/dashboard'>
            <img id='imglogo' src={logoImage} alt="logoImage" />
          </Link>
        </div>
        <button className={`btn-hamburger ${isNavOpen ? 'opened' : ''}`} onClick={toggleNav}>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </button>
        <ul className={`nav-menu ${isNavOpen ? 'opened' : ''}`} >
          <li className="nav-item"> <a href="/wsq/dashboard"><FontAwesomeIcon icon={faHome} /> Home </a></li>
          <li className="nav-item"><Link to="/wsq/batch"> <FontAwesomeIcon icon={faBook} /> Batches </Link></li>

          <li style={{ color: 'black' }} className={`nav-item dropdown ${isResourcesOpen ? 'show' : ''}`} ref={resourcesRef}>
            <a to={''} onClick={toggleResources}> <FontAwesomeIcon icon={faFolder} />  Resources <FontAwesomeIcon />  </a>
            {isResourcesOpen && (
  <div className="enhanced-dropdown dropdown-menu show">
    <Link className="dropdown-item dropdown-item-common" to='/wsq/category'>
      <FontAwesomeIcon icon={faFolder} className="icon-spacing" />Categories
    </Link>

    <Link className="dropdown-item dropdown-item-common" to='/wsq/sales'>
      <FontAwesomeIcon icon={faUser} className="icon-spacing" /> Sales Person
    </Link>

    {/* <Link className="dropdown-item dropdown-item-common" to='/wsq/WsqPayment'>
      <FontAwesomeIcon icon={faBook} className="icon-spacing" /> Payment Details
    </Link> */}

    <Link className="dropdown-item dropdown-item-common" to='/wsq/course'>
      <FontAwesomeIcon icon={faBook} className="icon-spacing" /> Course
    </Link>

    <Link className="dropdown-item dropdown-item-common" to='/wsq/student'>
      <FontAwesomeIcon icon={faUserCircle} className="icon-spacing" /> Student
    </Link>

    <Link className="dropdown-item dropdown-item-common" to='/wsq/Allcompany'>
      <FontAwesomeIcon icon={faBuilding} className="icon-spacing" /> Company
    </Link>

    <Link className="dropdown-item dropdown-item-common" to='/wsq/Venue'>
      <FontAwesomeIcon icon={faMapMarkerAlt} className="icon-spacing" /> Venues
    </Link>

    {/* <Link className="dropdown-item dropdown-item-common" to='/StudentReport'>
      <FontAwesomeIcon icon={faChartLine} className="icon-spacing" /> Student Report
    </Link> */}

    {/* <Link className="dropdown-item dropdown-item-common" to='/Feedbacks'>
      <FontAwesomeIcon icon={faComments} className="icon-spacing" /> Feedback
    </Link> */}
  </div>
)}

          </li>

          <li className="nav-item">
            <Link to='/Setting' >  <FontAwesomeIcon icon={faCog} /> Settings</Link></li>


          <li style={{ color: 'black' }} className={`nav-item dropdown ${isHelpOpen ? 'show' : ''}`} ref={helpRef}>

            <Link to='' onClick={toggleHelp}><FontAwesomeIcon icon={faQuestionCircle} /> Help <FontAwesomeIcon /></Link>

            <div className={`dropdown-menu ${isHelpOpen ? 'show' : ''}`}>

              <Link className="dropdown-item" to='/Chat'>Contact us</Link>


            </div>

          </li>



          <li
            className="nav-item"
            style={itemStyle}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
          >
            <Badge
              badgeContent={notificationCount}
              onClick={openNotificationsModal}
              color="error"
            // style={{ display: 'flex', alignItems: 'center' }} // Ensure badge and icon are centered
            >
              <NotificationsIcon />
              Notification
            </Badge>
            {/* <h6 style={{ margin: '0', fontSize: '16px', color: '#000' }}>Notification</h6> */}
          </li>





          <span style={{ width: '40px' }}>
            <li className={`nav-item dropdown ${isAccountOpen ? 'show' : ''}`}>
              <Link to='' onClick={toggleAccount}>
                {profileUrl ? (
                  <img
                    src={profileUrl}
                    alt="Profile"
                    style={{ marginLeft: '5px', borderRadius: '50%', width: '50px', height: '50px' }}
                  />
                ) : (
                  <span
                    style={{
                      marginLeft: '5px',
                      borderRadius: '50%',
                      width: '50px',
                      height: '50px',
                      backgroundColor: 'gray',
                    }}
                  ></span>
                )}
                {studentName ? (
                  studentName
                ) : (
                  <span className="placeholder-text">Loading</span>
                )}
                <FontAwesomeIcon />
              </Link>


              <div className={`dropdown-menu ${isAccountOpen ? 'show' : ''}`} ref={accountRef}>
                <Link className="dropdown-item" to="/Profile">Profile</Link>
                <Link onClick={handleLogout} className="dropdown-item" to='/'>
                  <FontAwesomeIcon icon={faSignOutAlt} /> Log out
                </Link>
              </div>
            </li>
          </span>
        </ul>
      </nav>
      <div className="container">

      </div>

      <Modal show={showNotificationsModal} onHide={closeNotificationsModal} fullscreen>
        <Modal.Header closeButton>
          <Modal.Title>Notifications</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {notifications.length === 0 ? (
            <p>No new notifications</p>
          ) : (
            <ul>
              {/* <h2>New students Were Added</h2> */}
              {notifications.map((notification) => (
                <li key={notification.id} className="notification-item">
                  <div className="notification-header">
                    <h3 className="notification-title">{notification.name}</h3>
                    <button
                      className="mark-seen-button"
                      onClick={() => markNotificationAsSeen(notification.id)}
                    >
                      Mark as Seen
                    </button>
                  </div>
                  <p className="notification-email">{notification.email}</p>
                  <p className="notification-phone">{notification.phoneNumber}</p>
                  {/* <p className="notification-message">{notification.message}</p> */}
                  <p className="notification-amount">Paid amount :{notification.amount}</p>
                  <p className="notification-amount">Intake Id  :{notification.intakeId}</p>
                </li>
              ))}
            </ul>
          )}

        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeNotificationsModal}>
            Close
          </Button>
          <Button style={{ width: "49px" }} variant="primary" onClick={markAllNotificationsAsSeen}>
            Mark All as Seen
          </Button>
        </Modal.Footer>
      </Modal>


    </div>
  );
}

export default App;
